import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-lt",
  "use": "icon-flag-lt-usage",
  "viewBox": "0 0 1541 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1541 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-lt\"><defs><style type=\"text/css\"></style></defs><path d=\"M6.315 1017.71h1520.904V6.29H6.315v1011.42z m1524.678 3.774v-3.774 3.774zM0.025 1024V0h1533.484v1024H0.025z\" fill=\"#353636\" p-id=\"2068\" /><path d=\"M3.799 681.828h1527.194v339.656H3.799z\" fill=\"#B53B4A\" p-id=\"2069\" /><path d=\"M3.799 342.172h1527.194v339.656H3.799z\" fill=\"#007659\" p-id=\"2070\" /><path d=\"M3.799 2.516h1527.194v339.656H3.799z\" fill=\"#EAB710\" p-id=\"2071\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-lt.svg
// module id = lApx
// module chunks = 24